export default "<div class=\"d-inline-flex flex-row position-fixed context-menu-container top-50 start-50 bg-white p-3 rounded\" >\n  tst\n</div>\n";